import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { kvs } from '../../reducers/kvs';
import actionCreators from '../../actions/kvsActions';

const useKvsActions = () => {
    const dispatch = useDispatch();

    return bindActionCreators({ ...actionCreators, ...kvs.actions }, dispatch);
};

export default useKvsActions;
